module.exports = __webpack_public_path__ + "media/images/app/visitors/testimonials/hero-9d58e4fd9a59cb3174f4cdb2b562408f.webp";